import { Action, Dispatch } from "redux";
import { FGetState } from "../app.reducer";
/**
 * Functon type declare
 */
export type FuncAction = (
    dispatch: Dispatch,
    getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    INIT_CUSTOMER_CARE: {
        LOADING: "INIT_CUSTOMER_CARE_LOADING",
        SUCCESS: "INIT_CUSTOMER_CARE_SUCCESS",
        ERROR: "INIT_CUSTOMER_CARE_ERROR",
    },
    SAVE_CUSTOMER_CARE: {
        LOADING: "SAVE_CUSTOMER_CARE_LOADING",
        SUCCESS: "SAVE_CUSTOMER_CARE_SUCCESS",
        CLEAN: "SAVE_CUSTOMER_CARE_CLEAN",
        ERROR: "SAVE_CUSTOMER_CARE_ERROR",
    },
};

/**
 * All store state
 */
export interface CustomerCareState {
    contents: Array<any>;
    resultSave: any;
    isLoading?: boolean;
    error?: any;
}

/**
 * Store's action definition
 */
export interface ICustomerCareAction extends Action {
    payload: any;
    error: any;
}
